import React, { useState, useEffect } from 'react';

import LockIcon from '../../assets/icons/LockIcon';

import Modal from '../shared/modal';
import ColorButton from '../shared/ColorButton';
import TextInput from '../shared/TextInput';
import SelectBox from '../shared/select/SelectBox';

import { defaultRankingAndActivity } from '../../constants/sales'

const RANK_OPTIONS = ["A", "B", "C", "D", "E"];

const RankingAndActivityModal = ({ open, onClose, onSubmit, surgeonRanking, loading }) => {
  const [data, setData] = useState({ ...defaultRankingAndActivity });

  useEffect(() => {
    if (open && surgeonRanking) {
      setData({ ...surgeonRanking });
    }
  }, [open]);

  const handleChange = (score, field, value) => {
    setData((prev) => ({
      ...prev,
      [score]: {
        ...prev[score],
        [field]: field === "activityTarget" ? Number(value) : value,
      },
    }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Edit Rank & Activity'
      className='create-pipeline-modal__container'
    >
      <div className='create-pipeline-modal__content'>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
          <tr>
            <th className='d-flex flex-center'>Score <LockIcon style={{ fontSize: 14, marginLeft: '6px' }} /></th>
            <th className='text-center'>Rank Category</th>
            <th className='text-center'>Min. Activity Target</th>
          </tr>
          </thead>
          <tbody>
          {Object.entries(data).map(([score, { rankCategory, activityTarget }]) => (
            <tr key={score}>
              <td className='font-size-bg font-bold' style={{ textAlign: "center" }}>{score}</td>
              <td>
                <SelectBox
                  value={rankCategory}
                  onChange={(value) =>  handleChange(score, "rankCategory", value)}
                  options={RANK_OPTIONS.map((opt) => ({ label: opt, value: opt }))}
                />
              </td>
              <td>
                <TextInput
                  type="number"
                  min="0"
                  value={activityTarget}
                  onChange={(e) => handleChange(score, "activityTarget", e.target.value)}
                />
              </td>
            </tr>
          ))}
          </tbody>
        </table>

        <div className='d-flex flex-end m-t-lg'>
          <div className='m-r-lg'>
            <ColorButton
              color='grey'
              text='Cancel'
              onClick={onClose}
            />
          </div>
          <ColorButton
            color='blue'
            text='Confirm'
            onClick={() => {
              onSubmit(data);
            }}
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  )
};

export default RankingAndActivityModal;
